import { Tag } from "@/models/tag";
import ApiService from "@/services/api/api.service";
import TagEndpoints from "@/services/tag/tag.endpoint";
import { CreateTagRequest, TagSchema, UpdateTagRequest } from "./tag.api.types";

export class TagService {
  static async getTagsByWorkspaceId(workspaceId: string): Promise<Tag[]> {
    const url = TagEndpoints.GET_TAGS_BY_WORKSPACE(workspaceId);

    const response = await ApiService.fetchData<never, TagSchema[]>({
      url,
      method: "GET",
    });

    return response.data.map(buildTag);
  }

  static async createTag(request: CreateTagRequest): Promise<Tag> {
    const response = await ApiService.fetchData<CreateTagRequest, TagSchema>({
      url: TagEndpoints.CREATE_TAG,
      method: "POST",
      data: request,
    });
    return buildTag(response.data);
  }

  static async updateTag(tagId: string, request: UpdateTagRequest): Promise<Tag> {
    const response = await ApiService.fetchData<UpdateTagRequest, TagSchema>({
      url: TagEndpoints.UPDATE_TAG(tagId),
      method: "PUT",
      data: request,
    });
    return buildTag(response.data);
  }
}

const buildTag = (tag: TagSchema): Tag =>
  new Tag(
    tag.id,
    tag.name,
    tag.description,
    new Date(tag.createdAt),
    new Date(tag.updatedAt),
  );
